// extracted by mini-css-extract-plugin
export default {"purchase":"Purchase_purchase__wPvGy","title":"Purchase_title__qLqgS","description":"Purchase_description__UGmwF","items":"Purchase_items__pEEne"};